<template>
  <div>
    <v-container>
      <h2>
        Your Beacons
        <v-modal-help style="font-size:17px">
          <div slot="body">
            <v-card-text>
              <h3 class="mb-2">LINE Beacon (บีคอน)</h3>
              <p style="color:black">
                เป็นเทคโนโลยีที่ใช้สำหรับการส่งข้อความในไลน์ผ่าน Bluetooth ได้ฟรี โดยไม่เสียค่า Push
                Message โดยเมื่อเราเดินเข้าไปในรัศมีที่มี LINE Beacon ส่งสัญญาณถึง ก็จะได้รับข้อความ
                รูปภาพ ที่ร้านค้าตั้งไว้ทันที
              </p>
            </v-card-text>
          </div>
        </v-modal-help>
      </h2>

      <div>
        <div v-if="loadingAdd" class="spinner text-xs-center mt-5">
          <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
        </div>
        <template v-else>
          <div style="margin-bottom: 10px;">
            <a
              href="javascript:void(0);"
              v-if="!isShow"
              @click="
                isShow = true
                beaconItem = {}
              "
            >
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('Add Beacon information') }}
              </div>
            </a>
            <div class="intent-item z-border-red" v-else style="padding: 10px 15px 0px;">
              <form>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has('beacon_id') }"
                    >
                      <label
                        >{{ $t('Beacon ID') }}
                        <v-modal-help :size="'1em'" style="font-size:17px">
                          <div slot="body">
                            <v-card-text>
                              <h3 class="mb-2">Beacon ID คือ</h3>
                              <p style="color:black">
                                เลขรหัสด้านหลังตัวบีคอนของคุณ เช่น HWID : 000006666e ดังนั้น Beacon
                                ID คือ 000006666e
                              </p>
                            </v-card-text>
                          </div>
                        </v-modal-help></label
                      >
                      <input
                        :data-vv-as="$t('Beacon ID')"
                        v-model="beaconItem.beacon_id"
                        v-validate="'required'"
                        name="beacon_id"
                        class="form-control"
                        type="text"
                      />
                      <span class="text-error" v-if="errors.has('beacon_id')">{{
                        errors.first('beacon_id')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div
                      class="form-control pa-1 mt-1"
                      :class="{ 'has-error': errors.has(`name`) }"
                    >
                      <label>{{ $t('Name') }}</label>
                      <input
                        :data-vv-as="$t('Name')"
                        v-model="beaconItem.name"
                        :name="`name`"
                        class="form-control mr-3"
                        type="text"
                      />
                      <span class="text-error" v-if="errors.has(`name`)">{{
                        errors.first(`name`)
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="form-control pa-1" :class="{ 'has-error': errors.has(`location`) }">
                      <label>{{ $t('Location') }}</label>
                      <input
                        :data-vv-as="$t('Location')"
                        v-model="beaconItem.location"
                        :name="`location`"
                        class="form-control mr-3"
                        type="text"
                      />
                      <span class="text-error" v-if="errors.has(`location`)">{{
                        errors.first(`location`)
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="form-control pa-1" :class="{ 'has-error': errors.has(`tag`) }">
                      <label>{{ $t('Tag') }}</label>
                      <input
                        :data-vv-as="$t('Tag')"
                        v-model="beaconItem.tag"
                        :name="`tag`"
                        class="form-control mr-3"
                        type="text"
                      />
                      <span class="text-error" v-if="errors.has(`tag`)">{{
                        errors.first(`tag`)
                      }}</span>
                    </div>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-btn outline color="grey" :loading="loadingAdd" @click="isShow = false">{{
                    $t('cancel')
                  }}</v-btn>
                  <v-btn depressed color="primary" :loading="loadingAdd" @click="saveIntent">{{
                    $t('Save')
                  }}</v-btn>
                </div>
              </form>
            </div>
          </div>

          <div
            class="intent-item z-border-red"
            style="padding: 10px 15px 10px;"
            v-for="(item, index) in data"
            :key="index"
          >
            <h3>Name : {{ item.name }}</h3>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pa-2">
                <tr>
                  <td class="primary-color">Beacon ID</td>
                  <td style="color:#000" class="pl-2">{{ item.beacon_id }}</td>
                </tr>
                <tr>
                  <td class="primary-color">Location</td>
                  <td style="color:#000" class="pl-2">{{ item.location }}</td>
                </tr>
                <tr>
                  <td class="primary-color">Tag</td>
                  <td style="color:#000" class="pl-2">{{ item.tag }}</td>
                </tr>
              </v-flex>

              <v-flex xs12 sm6 class="text-xs-right">
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  @click="editIntent(item)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </v-btn>
                <v-btn
                  fab
                  outline
                  :loading="loadingDelete"
                  color="primary"
                  class="extra-small ma-1"
                  @click="deleteBeaconsList(item)"
                >
                  <i class="fa fa-trash middle"></i>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <v-dialog v-if="isEdit" persistent v-model="isEdit" max-width="1000">
          <v-card>
            <div class="text-xs-right">
              <v-btn flat small fab @click="isEdit = false">
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="intent-item z-border-red" style="padding: 10px 15px 0px;">
                <form>
                  <v-layout wrap>
                    <v-flex xs12 sm6>
                      <div
                        class="form-control pa-1"
                        :class="{ 'has-error': errors.has('beacon_id') }"
                      >
                        <label>{{ $t('Beacon ID') }}</label>
                        <input
                          :data-vv-as="$t('Beacon ID')"
                          v-model="beaconItemEdit.beacon_id"
                          v-validate="'required'"
                          name="beacon_id"
                          class="form-control"
                          type="text"
                          disabled
                        />
                        <span class="text-error" v-if="errors.has('beacon_id')">{{
                          errors.first('beacon_id')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="form-control pa-1" :class="{ 'has-error': errors.has(`name`) }">
                        <label>{{ $t('Name') }}</label>
                        <input
                          :data-vv-as="$t('Name')"
                          v-model="beaconItemEdit.name"
                          v-validate="'required'"
                          :name="`name`"
                          class="form-control mr-3"
                          type="text"
                        />
                        <span class="text-error" v-if="errors.has(`name`)">{{
                          errors.first(`name`)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div
                        class="form-control pa-1"
                        :class="{ 'has-error': errors.has(`location`) }"
                      >
                        <label>{{ $t('Location') }}</label>
                        <input
                          :data-vv-as="$t('Location')"
                          v-model="beaconItemEdit.location"
                          v-validate="'required'"
                          :name="`location`"
                          class="form-control mr-3"
                          type="text"
                        />
                        <span class="text-error" v-if="errors.has(`location`)">{{
                          errors.first(`location`)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="form-control pa-1" :class="{ 'has-error': errors.has(`tag`) }">
                        <label>{{ $t('Tag') }}</label>
                        <input
                          :data-vv-as="$t('Tag')"
                          v-model="beaconItemEdit.tag"
                          v-validate="'required'"
                          :name="`tag`"
                          class="form-control mr-3"
                          type="text"
                        />
                        <span class="text-error" v-if="errors.has(`tag`)">{{
                          errors.first(`tag`)
                        }}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                  <div class="text-xs-center">
                    <v-btn :loading="loadingAdd" outline color="grey" @click="isEdit = false">{{
                      $t('cancel')
                    }}</v-btn>
                    <v-btn
                      :loading="loadingAdd"
                      depressed
                      color="primary"
                      @click="postBeaconsList(beaconItemEdit, 'edit')"
                      >{{ $t('Save') }}</v-btn
                    >
                  </div>
                </form>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isShow: false,
      data: [],
      isEdit: false,
      beaconItem: {},
      beaconItemEdit: {},
      loadingAdd: false,
      loadingDelete: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.getBeaconsList(100, 0)
  },
  methods: {
    async getBeaconsList(limit, offset) {
      try {
        this.loadingAdd = true
        var res = await api.getBeaconsList({
          pageid: this.selectedBot.pageid,
          limit: limit,
          offset: offset
        })
        if (res.success) {
          this.data = res.result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          this.loadingAdd = false
        } else {
          this.loadingAdd = false
        }
      } catch (error) {
        console.error(error)
        this.loadingAdd = false
      }
    },
    async postBeaconsList(beaconItem, type) {
      this.loadingAdd = true
      var res = await api.postBeaconsList({
        pageid: this.selectedBot.pageid,
        body: {
          beacon_id: beaconItem.beacon_id,
          name: beaconItem.name, // optional
          location: beaconItem.location, // optional
          tag: beaconItem.tag // optional
        }
      })
      if (res.success) {
        if (type === 'add') {
          this.isShow = false
          this.$swal.fire({
            title: this.$t('Successfully'),
            text: `Beacon ${beaconItem.name} ถูกเพิ่มแล้ว`,
            type: 'success'
          })
        } else {
          this.isEdit = false
          this.$swal.fire({
            title: this.$t('Successfully'),
            text: `Beacon ${beaconItem.name} ถูกแก้ไขแล้ว`,
            type: 'success'
          })
        }
        this.getBeaconsList(100, 0)
        this.loadingAdd = false
      } else {
        this.loadingAdd = false
      }
    },

    async saveIntent() {
      let result = await this.$validator.validateAll()
      if (result) {
        this.postBeaconsList(this.beaconItem, 'add')
      }
    },
    editIntent(item) {
      var beacon = JSON.stringify(item)
      this.beaconItemEdit = JSON.parse(beacon)
      this.isEdit = true
    },
    async deleteBeaconsList(item) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: 'Beacon ' + item.name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.loadingDelete = true
        var res = await api.deleteBeaconsList({
          pageid: this.selectedBot.pageid,
          config_id: item.id
        })
        if (res.success) {
          if (this.data.length > 0) {
            this.data = this.data.filter(function(value) {
              return value.id !== item.id
            })
          }
          this.loadingDelete = false
          this.$swal.fire({
            title: this.$t('Successfully'),
            text: `Beacon ${item.name} ถูกลบแล้ว`,
            type: 'success'
          })
          this.getBeaconsList(100, 0)
        } else {
          this.loadingDelete = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/Beacon.vue